export default {
  items: [
    {
      title: true,
      name: "DASHBOARD",
      wrapper: {
        // optional wrapper object
        element: "", // required valid HTML5 element tag
        attributes: {}, // optional valid JS object with JS API naming ex: { className: "my-class", style: { fontFamily: "Verdana" }, id: "my-id"}
      },
      class: "", // optional class names space delimited list for title item ex: "text-center"
      resps: ["ADMIN", "AHH", "CMP", "FBP", "AR", "STN", "GIO"],
    },
    {
      name: "Welcome",
      url: "/welcome",
      icon: "fa fa-chevron-right",
      resps: [
        "ADMIN",
        "HR",
        "ACCOUNTING",
        "MANAGER",
        "USER",
        "FBP",
        "AR",
        "STN",
        "GIO",
      ],
    },
    {
      name: "Overall Dashboard",
      icon: "fa fa-chevron-right",
      resps: [
        "ADMIN",
        "MANAGER",
        // "ACCOUNTING",
        // "HR",
        // "AHH",
        // "CMP",
        // "FBP",
        // "AR",
        // "STN",
        // "GIO",
        // "FMR",
        // "EM",
        // "ENS",
        // "YN",
      ],
      children: [
        {
          name: "Dashboard",
          url: "/dashboard",
          resps: [
            "ADMIN",
            "ACCOUNTING",
            "AHH",
            "CMP",
            "FBP",
            "AR",
            "STN",
            "GIO",
          ],
          icon: "icon-speedometer",
        },
        // {
        //   name: "Hpp Regulasi",
        //   url: "/hppregulasi",
        //   resps: ["ADMIN"],
        //   icon: "icon-speedometer",
        // },
        // {
        //   name: "Hpp Putusan",
        //   url: "/hppputusan",
        //   resps: ["ADMIN"],
        //   icon: "icon-speedometer",
        // },
        {
          name: "Business Dashboard",
          url: "/businessdashboard",
          resps: ["ADMIN", "ACCOUNTING", "MANAGER"],
          icon: "fa fa-dashboard",
        },
        {
          name: "Finance Dashboard",
          url: "/financedashboard",
          resps: ["ADMIN", "ACCOUNTING", "MANAGER"],
          icon: "fa fa-dollar",
        },
        {
          name: "HC Dashboard",
          url: "/hcdashboard",
          resps: ["ADMIN", "HR"],
          icon: "fa fa-users",
        },
        // {
        //   name: "Supporting Dashboard",
        //   url: "/supportingDashboard",
        //   resps: ["ADMIN"],
        //   icon: "fa fa-question-circle",
        // },
      ],
    },
    {
      name: "Finance",
      icon: "fa fa-chevron-right",
      resps: ["ADMIN", "ACCOUNTING"],
      url: "#/",
      children: [
        {
          name: "Cash Flow",
          icon: "fa fa-line-chart",
          resps: ["ADMIN", "ACCOUNTING", "!YN", "!GCW"],
          url: "/cashflow",
        },
        {
          name: "Cash adjustment",
          icon: "fa fa-line-chart",
          resps: ["ADMIN", "ACCOUNTING"],
          url: "/CashAdjustMent",
        },
        {
          name: "Cash Position",
          icon: "fa fa-map-marker",
          resps: ["ADMIN", "ACCOUNTING"],
          url: "/CashPosition",
        },

        {
          name: "Petty Cash",
          icon: "fa fa-money",
          resps: ["ADMIN", "ACCOUNTING"],
          url: "/pettycash",
        },
        {
          name: "Account Receivable",
          icon: "fa fa-angle-double-right",
          resps: ["ADMIN", "ACCOUNTING"],
          url: "#/",
          children: [
            {
              name: "List",
              url: "/arlist",
              resps: ["ADMIN", "ACCOUNTING"],
              icon: "fa fa-file-excel-o",
            },
            {
              name: "Input",
              url: "/arinput",
              resps: ["ADMIN", "ACCOUNTING"],
              icon: "fa fa-wpforms",
            },
            {
              name: "Loan Payment",
              url: "/loan_payment",
              resps: ["ADMIN", "ACCOUNTING"],
              icon: "fa fa-codepen",
            },
          ],
        },
        {
          name: "Account Payable",
          icon: "fa fa-angle-double-right",
          resps: ["ADMIN", "ACCOUNTING"],
          url: "#/",
          children: [
            {
              name: "List",
              url: "/aplist",
              resps: ["ADMIN", "ACCOUNTING"],
              icon: "fa fa-file-excel-o",
            },
            {
              name: "Input",
              url: "/apinput",
              resps: ["ADMIN", "ACCOUNTING", "HR"],
              icon: "fa fa-wpforms",
            },
            {
              name: "Exchange payment",
              url: "/exchange-payment",
              resps: ["ADMIN", "ACCOUNTING"],
              icon: "fa fa-codepen",
            },
          ],
        },
        // {
        //   name: "Timesheet Export",
        //   icon: "fa fa-calendar-o",
        //   resps: ["ADMIN", "ACCOUNTING"],
        //   url: "/timesheet-export",
        // },
      ],
    },
    {
      title: true,
      name: "PROJECTS",
      wrapper: {
        // optional wrapper object
        element: "", // required valid HTML5 element tag
        attributes: {}, // optional valid JS object with JS API naming ex: { className: "my-class", style: { fontFamily: "Verdana" }, id: "my-id"}
      },
      class: "", // optional class names space delimited list for title item ex: "text-center"
      resps: ["ADMIN", "USER", "MANAGER", "HR"],
    },
    {
      name: "Prospect",
      // url: "",
      resps: ["ADMIN", "USER", "MANAGER", "HR"],
      icon: "fa fa-chevron-right",
      children: [
        {
          name: "Prospect Board",
          url: "/caseboard/overview",
          resps: ["ADMIN", "USER", "MANAGER"],
          icon: "fa fa-sticky-note",
        },
        {
          name: "Prospect List",
          url: "/prospectlist",
          resps: ["ADMIN", "USER", "MANAGER"],
          icon: "fa fa-th-list",
        },
        {
          name: "Add New Prospect",
          url: "/caseprospect",
          resps: ["ADMIN", "MANAGER"],
          icon: "fa fa-plus",
        },
      ],
    },
    {
      name: "Leads",
      // url: "",
      resps: ["ADMIN", "USER", "MANAGER"],
      icon: "fa fa-chevron-right",
      children: [
        {
          name: "Leads",
          url: "/meetinglog",
          resps: ["ADMIN", "USER", "MANAGER"],
          icon: "fa fa-history",
        },
        {
          name: "Potential Clients",
          url: "/potentialclient",
          resps: ["ADMIN", "USER", "MANAGER"],
          icon: "fa fa-users",
        },
      ],
    },
    // {
    //   name: "Contract",
    //   // url: "",
    //   resps: ["ADMIN", "USER", "MANAGER"],
    //   icon: "fa fa-chevron-right",
    //   children: [
    //     {
    //       name: "Contract List",
    //       url: "/contract-list",
    //       resps: ["ADMIN", "USER", "MANAGER"],
    //       icon: "fa fa-th-list",
    //     },
    //     {
    //       name: "Add New Contract",
    //       url: "/contract-management",
    //       resps: ["ADMIN", "MANAGER"],
    //       icon: "fa fa-plus",
    //     },
    //   ],
    // },
    {
      name: "Projects",
      // url: "",
      resps: ["ADMIN", "USER", "MANAGER"],
      icon: "fa fa-chevron-right",
      children: [
        {
          name: "Project Overview",
          url: "/cases",
          resps: ["ADMIN", "USER", "MANAGER"],
          icon: "fa fa-eye",
        },
        {
          name: "Project Board",
          url: "/caseboard/only_active",
          resps: ["ADMIN", "USER", "MANAGER"],
          icon: "fa fa-sticky-note",
        },
        {
          name: "Project List",
          url: "/caselist",
          resps: ["ADMIN", "USER", "MANAGER"],
          icon: "fa fa-th-list",
        },
        {
          name: "Add New Project",
          url: "/casenew",
          resps: ["ADMIN", "MANAGER"],
          icon: "fa fa-plus",
        },
        // {
        //   name: "Non-Client (BUSD)",
        //   url: "/routine_activity",
        //   icon: "fa fa-th-list",
        //   resp: ["ADMIN", "MANAGER"],
        // },
      ],
    },

    {
      title: true,
      name: "PERSONAL",
      wrapper: {
        // optional wrapper object
        element: "", // required valid HTML5 element tag
        attributes: {}, // optional valid JS object with JS API naming ex: { className: "my-class", style: { fontFamily: "Verdana" }, id: "my-id"}
      },
      class: "", // optional class names space delimited list for title item ex: "text-center"
      resps: ["ADMIN", "USER", "MANAGER"],
    },

    {
      name: "User Profile",
      url: "/profile/13/info",
      resps: ["ADMIN", "USER", "MANAGER"],
      icon: "fa fa-user",
    },
    //timesheet url
    {
      name: "Timesheet",
      // url: "#/",
      resps: ["ADMIN", "USER", "MANAGER"],
      icon: "fa fa-chevron-right",
      children: [
        {
          name: "Timesheet",
          url: "/timesheet/input",
          resps: ["ADMIN", "USER", "MANAGER"],
          icon: "fa fa-calendar",
        },
        {
          name: "Timesheet List",
          url: "/Timesheet_search",
          resps: ["ADMIN", "USER", "MANAGER"],
          icon: "fa fa-calendar-o",
        },
        {
          name: "Timesheet Review",
          url: "/timesheets/view",
          resps: ["ADMIN", "USER", "MANAGER"],
          icon: "fa fa-eye",
        },
        {
          name: "Timesheet Lock",
          url: "/master/TimesheetLock",
          resps: ["ADMIN", "USER", "MANAGER"],
          icon: "fa fa-user",
        },
        {
          name: "Timesheet Export",
          icon: "fa fa-download",
          resps: ["ADMIN"],
          url: "/timesheet-export",
        },
      ],
    },
    {
      name: "Timesheet Non-Client",
      // url: "#/",
      resps: ["ADMIN", "USER", "MANAGER"],
      icon: "fa fa-chevron-right",
      children: [
        {
          name: "Timesheet",
          url: "/timesheet/routine",
          resps: ["ADMIN", "USER", "MANAGER"],
          icon: "fa fa-calendar",
        },
        {
          name: "Timesheet List",
          url: "/Timesheet_routine",
          resps: ["ADMIN", "USER", "MANAGER"],
          icon: "fa fa-calendar-o",
        },
      ],
    },
    // {
    //   name: "Forecast",
    //   url: "/forecastpersonal",
    //   resps: ["ADMIN", "PARTNERS", "MPARTNER", "PARTNERQ"],
    //   icon: "fa fa-bullseye",
    // },
    {
      title: true,
      name: "HUMAN CAPITAL",
      wrapper: {
        element: "",
        attributes: {},
      },
      class: "",
      resps: ["ADMIN", "USER", "MANAGER", "HR"],
    },

    {
      name: "Attendance List",
      url: "/HC/Attendance",
      resps: ["ADMIN", "USER", "MANAGER", "HR"],
      icon: "fa fa-clock-o",
    },
    {
      name: "Employee List",
      url: "/HC/employee_list",
      resps: ["ADMIN", "USER", "MANAGER", "HR"],
      icon: "fa fa-users",
    },
    {
      name: "Leave",
      url: "#/",
      resps: ["ADMIN", "USER", "MANAGER", "HR"],
      icon: "fa fa-chevron-right",
      children: [
        {
          name: "List",
          url: "/HC/leave_list",
          resps: ["ADMIN", "USER", "MANAGER", "HR"],
          icon: "fa fa-list-alt",
        },
        {
          name: "Approval",
          url: "/HC/leave_approval",
          resps: ["ADMIN", "USER", "MANAGER", "HR"],
          icon: "fa fa-check",
        },
        {
          name: "Override Approval",
          url: "/HC/override_leave_approval",
          resps: ["ADMIN", "HR"],
          icon: "fa fa-unlock",
        },
      ],
    },
    {
      name: "Reimbursement",
      url: "#/",
      resps: ["ADMIN", "USER", "MANAGER", "HR", "ACCOUNTING"],
      icon: "fa fa-chevron-right",
      children: [
        {
          name: "List",
          url: "/HC/reimbursement_list",
          resps: ["ADMIN", "USER", "MANAGER", "HR", "ACCOUNTING"],
          icon: "fa fa-list-alt",
        },
        {
          name: "Approval",
          url: "/HC/reimbursement_approval",
          resps: ["ADMIN", "USER", "MANAGER", "HR", "ACCOUNTING"],
          icon: "fa fa-check",
        },
        {
          name: "Override Approval",
          url: "/HC/reimbursement_override_approval",
          resps: ["ADMIN", "HR", "ACCOUNTING"],
          icon: "fa fa-unlock",
        },
      ],
    },
    {
      name: "Medical Insurance",
      url: "#/",
      resps: ["ADMIN", "HR"],
      icon: "fa fa-chevron-right",
      children: [
        {
          name: "List",
          url: "/HC/reimbursement_medical_insurance_list",
          resps: ["ADMIN", "USER", "MANAGER", "HR"],
          icon: "fa fa-list-alt",
        },
        {
          name: "Override",
          url: "/HC/reimbursementMedicalOverride",
          resps: ["ADMIN", "HR"],
          icon: "fa fa-unlock",
        },
        {
          name: "Approval",
          url: "/HC/reimbursementMedicalApproval",
          resps: ["ADMIN", "USER", "MANAGER", "HR"],
          icon: "fa fa-check",
        },
      ],
    },
    {
      name: "Loan",
      url: "#/",
      resps: ["ADMIN", "USER", "MANAGER", "HR"],
      icon: "fa fa-chevron-right",
      children: [
        {
          name: "List",
          url: "/HC/loan_list",
          resps: ["ADMIN", "USER", "MANAGER", "HR"],
          icon: "fa fa-list-alt",
        },
        {
          name: "Approval",
          url: "/HC/loan_approval",
          resps: ["ADMIN", "USER", "MANAGER", "HR"],
          icon: "fa fa-check",
        },
        {
          name: "Override Approval",
          url: "/HC/override_loan_approval",
          resps: ["ADMIN", "HR"],
          icon: "fa fa-unlock",
        },
      ],
    },
    {
      name: "Payroll Slip",
      icon: "fa fa-money",
      url: "/payroll-slip",
      resps: ["ADMIN", "HR"],
    },
    {
      name: "Advance",
      url: "#/",
      resps: ["ADMIN", "USER", "MANAGER"],
      icon: "fa fa-chevron-right",
      children: [
        {
          name: "List",
          url: "/HC/advance_list",
          resps: ["ADMIN", "USER", "MANAGER"],
          icon: "fa fa-list-alt",
        },
        {
          name: "Approval",
          url: "/HC/advance_approval",
          resps: ["ADMIN", "USER", "MANAGER"],
          icon: "fa fa-check",
        },
        {
          name: "Override Approval",
          url: "/HC/override_advance_approval",
          resps: ["ADMIN", "ACCOUNTING", "HR"],
          icon: "fa fa-unlock",
        },
      ],
    },

    {
      title: true,
      name: "ADMINISTRATOR",
      wrapper: {
        // optional wrapper object
        element: "", // required valid HTML5 element tag
        attributes: {}, // optional valid JS object with JS API naming ex: { className: "my-class", style: { fontFamily: "Verdana" }, id: "my-id"}
      },
      class: "", // optional class names space delimited list for title item ex: "text-center"
      resps: ["ADMIN", "HR"],
    },
    {
      name: "Administrator",
      icon: "fa fa-book",
      resps: ["ADMIN"],
      url: "",
      children: [
        {
          name: "Master Data Bank",
          url: "/create_bank",
          resps: ["ADMIN", "ACCOUNTING"],
          icon: "fa fa-chevron-right",
        },

        {
          name: "Matter",
          url: "/matter_configurations",
          resps: ["ADMIN"],
          icon: "fa fa-chevron-right",
          children: [
            {
              name: "Matter Update Template",
              url: "/matter_configurations/case_update_template",
              resps: ["ADMIN"],
              icon: "fa fa-flag",
            },
            {
              name: "Case Flags",
              url: "/matter_configurations/case_flags",
              resps: ["ADMIN"],
              icon: "fa fa-flag",
            },
          ],
        },
      ],
    },
    {
      name: "Human Capital",
      // url: "/human_capital",
      resps: ["ADMIN", "HR"],
      icon: "fa fa-chevron-right",
      children: [
        {
          name: "Leave",
          // url: "/human_capital",
          resps: ["ADMIN", "HR"],
          icon: "fa fa-angle-double-right",
          children: [
            {
              name: "Leave Request Limit",
              url: "/leave/Leave_request_limit",
              resps: ["ADMIN", "HR"],
              icon: "fa fa-bus",
            },
            {
              name: "Leave Category",
              url: "/leave_request_category",
              resps: ["ADMIN", "HR"],
              icon: "fa fa-bus",
            },
            {
              name: "Peak Season",
              url: "/HC/peakseason",
              resp: ["ADMIN", "HR"],
              icon: "fa fa-bus",
            },
            {
              name: "Leave Daily Allowance",
              url: "/HC/DailyleaveAllowance",
              resps: ["ADMIN", "HR"],
              icon: "fa fa-bus",
            },
          ],
        },
        {
          name: "Reimbursement",
          // url: "/human_capital",
          resps: ["ADMIN", "HR"],
          icon: "fa fa-angle-double-right",
          children: [
            {
              name: "Medical Plan",
              url: "/human_capital/med_reimbursement_plan",
              resps: ["ADMIN", "HR"],
              icon: "fa fa-ambulance",
            },
            {
              name: "Reimbursement Limit",
              url: "/reimbursement_request_limit",
              resps: ["ADMIN", "HR"],
              icon: "fa fa-compress",
            },
            {
              name: "Reimbursement Type",
              url: "/Reimbursement",
              resps: ["ADMIN", "HR"],
              icon: "fa fa-compress",
            },
          ],
        },
        {
          name: "Attendance",
          // url: "/human_capital",
          resps: ["ADMIN"],
          icon: "fa fa-angle-double-right",
          children: [
            {
              name: "Divisions",
              url: "/attendance_division/division_list",
              resps: ["ADMIN"],
              icon: "fa fa-bus",
            },
            {
              name: "Employee Assignment",
              url: "/attendance_division/division_assignment",
              resps: ["ADMIN"],
              icon: "fa fa-bus",
            },
          ],
        },
      ],
    },
    {
      name: "Approval System",
      url: "/approvals",
      resps: ["ADMIN"],
      icon: "fa fa-chevron-right",
      children: [
        {
          name: "General Approval System",
          url: "/approvals/general",
          resps: ["ADMIN"],
          icon: "fa fa-check-circle",
        },
        {
          name: "Approval Settings",
          url: "/approvals/settings",
          resps: ["ADMIN", "HC", "ACCOUNTING"],
          icon: "fa fa-check-circle",
        },
      ],
    },
    {
      name: "Assignment",
      icon: "fa fa-chevron-right",
      url: "/assignment",
      resps: ["ADMIN"],
      children: [
        {
          name: "Medical Assigment",
          url: "/human_capital/medicalInsuranceAssigment",
          resp: ["ADMIN", "HC"],
          icon: "fa fa-ambulance",
        },
      ],
    },
    {
      name: "Master Data",
      icon: "fa fa-chevron-right",
      resps: ["ADMIN", "ACCOUNTING"],
      url: "/adminstrator",
      children: [
        {
          name: "User Login",
          url: "/users",
          resps: ["ADMIN"],
          icon: "fa fa-user",
        },
        {
          name: "Lawyer Practice",
          url: "/master/LawyerPracticesMaster",
          resps: ["ADMIN"],
          icon: "fa fa-user",
        },
        {
          name: "Practices",
          url: "/master/practices",
          resps: ["ADMIN"],
          icon: "fa fa-user",
        },
        {
          name: "Lawyer Sector",
          url: "/master/LawyerSectorMaster",
          resps: ["ADMIN"],
          icon: "fa fa-user",
        },
        {
          name: "Sectors",
          url: "/master/sectors",
          resps: ["ADMIN"],
          icon: "fa fa-user",
        },
        {
          name: "Vendors",
          url: "/master/vendors",
          resps: ["ADMIN", "ACCOUNTING"],
          icon: "fa fa-user",
        },
        {
          name: "Document Type",
          url: "/master/document_types",
          resps: ["ADMIN"],
          icon: "fa fa-file",
        },
        {
          name: "Forecast",
          url: "/forecast",
          resps: ["ADMIN", "ACCOUNTING", "PARTNERS", "MPARTNER", "PARTNERQ"],
          icon: "fa fa-bullseye",
        },
        {
          name: "User Management",
          icon: "fa fa-chevron-right",
          url: "/usermanagement",
          resps: ["ADMIN", "HR"],
          children: [
            {
              name: "Add New User",
              url: "/master/user-management",
              resps: ["ADMIN", "HR"],
              icon: "fa fa-plus",
            },
            {
              name: "User List",
              url: "/master/user-list",
              resps: ["ADMIN", "HR"],
              icon: "fa fa-th-list",
            },
          ],
        },
        {
          name: "Active Member Management",
          icon: "fa fa-chevron-right",
          url: "/lawyermanagement",
          resps: ["ADMIN"],
          children: [
            {
              name: "Add New Member",
              url: "/master/member-management",
              resps: ["ADMIN"],
              icon: "fa fa-plus",
            },
            {
              name: "Member List",
              url: "/master/member-list",
              resps: ["ADMIN"],
              icon: "fa fa-th-list",
            },
          ],
        },
      ],
    },
  ],
};
